import React from 'react';
import Layout from '../../components/layout/Layout';
import Section from '../../components/layout/Section';
import Container from '../../components/layout/Container';

const CookiesPolicy: React.FC = () => {
  return (
    <Layout>
      <Section className="py-16">
        <Container>
          <div className="max-w-4xl mx-auto">
            <h1 className="text-4xl font-bold mb-8">Cookies Policy</h1>
            <div className="prose prose-lg">
              <p className="mb-6">Last updated: May 7, 2025</p>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold mb-4">What Are Cookies?</h2>
                <p>
                  Cookies are small text files that are stored on your computer or mobile device when you visit our website. They help us make the site work better and improve your user experience.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold mb-4">How We Use Cookies</h2>
                <p>We use cookies for the following purposes:</p>
                <ul className="list-disc pl-6 mb-4">
                  <li>Essential cookies for site functionality</li>
                  <li>Analytics cookies to understand user behavior</li>
                  <li>Preference cookies to remember your settings</li>
                  <li>Marketing cookies for targeted advertising</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold mb-4">Types of Cookies We Use</h2>
                <div className="space-y-4">
                  <div>
                    <h3 className="text-xl font-semibold mb-2">Essential Cookies</h3>
                    <p>Required for basic site functionality. These cannot be disabled.</p>
                  </div>
                  
                  <div>
                    <h3 className="text-xl font-semibold mb-2">Performance Cookies</h3>
                    <p>Help us understand how visitors interact with our website by collecting anonymous information.</p>
                  </div>
                  
                  <div>
                    <h3 className="text-xl font-semibold mb-2">Functionality Cookies</h3>
                    <p>Remember choices you make to improve your experience.</p>
                  </div>
                  
                  <div>
                    <h3 className="text-xl font-semibold mb-2">Marketing Cookies</h3>
                    <p>Used to track visitors across websites to enable personalized advertising.</p>
                  </div>
                </div>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold mb-4">Managing Cookies</h2>
                <p>
                  Most web browsers allow you to control cookies through their settings preferences. However, limiting cookies may impact your experience using our website.
                </p>
                <p className="mt-4">
                  To learn more about cookies and how to manage them, visit:
                  <a href="https://www.aboutcookies.org" className="text-primary hover:underline ml-1" target="_blank" rel="noopener noreferrer">
                    www.aboutcookies.org
                  </a>
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold mb-4">Your Choices</h2>
                <p>
                  When you first visit our website, you will be given the option to accept or decline non-essential cookies. You can change your preferences at any time through our cookie settings panel.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold mb-4">Contact Us</h2>
                <p>
                  If you have any questions about our use of cookies, please contact us at:
                  <br />
                  Email: privacy@codemyai.com
                </p>
              </section>
            </div>
          </div>
        </Container>
      </Section>
    </Layout>
  );
};

export default CookiesPolicy;